function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';
const colors = {
  green: '#daf0ed',
  pink: '#f9c3c7'
};
const SvgComponent = /*#__PURE__*/forwardRef(({
  color,
  height,
  size,
  width,
  outline,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: width || size,
    height: height || size
  }, rest, {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8739 2.7636c-2.3018-.013-4.42-.0194-6.7217-.0317a.313.313 0 00-.3034.3098c-.0064 2.2954.057 4.4322.0447 6.7263a.2102.2102 0 00.0646.1513.0065.0065 0 00.0065.0065l.0188.0187c.0418.032.0928.05.1455.0511 2.3083.0059 4.4387 0 6.747.0375a.2484.2484 0 00.2399-.2399c.0252-2.3018.0446-4.4322.0569-6.734a.3092.3092 0 00-.2988-.2956zm-.2535 6.7715l-3.2118.0188c-1.075-.0065-1.9726-.0065-3.054-.0123.0194-2.1181.0317-4.0972.0446-6.2153 2.0988.0065 4.0403-.0065 6.139-.0065.0065 1.005.0447 1.9604.0511 2.959 0 .8032.0188 1.5302.031 2.3334a7.5182 7.5182 0 000 .923z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.433 9.7183c-.0065-.0064-.0065-.0064-.0065-.0123 0-.0058 0-.0194-.0065-.0317-1.1842-2.3347-2.3024-4.6941-3.473-7.0347a.3237.3237 0 00-.4205-.105.3225.3225 0 00-.1163.105c-1.2418 2.3341-2.3995 4.7-3.6348 7.0347a.231.231 0 00.2005.3422c2.4124 0 4.8248.0064 7.2436.0064a.0694.0694 0 01.0324-.0064.2156.2156 0 00.1875-.2283.143.143 0 00-.0064-.0699zM12.3639 9.56c1.0931-2.0425 2.2249-4.0655 3.3114-6.1145 1.0478 2.0425 2.1214 4.0746 3.162 6.121-2.1595-.0065-4.3132-.0065-6.4734-.0065z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4198 15.1151a3.9355 3.9355 0 00-4.4044-3.3826c-2.1601.2005-3.4148 1.9726-3.4795 4.0487 0 .0065.0065.0065.0065.0194a3.8487 3.8487 0 001.4241 2.87 3.847 3.847 0 001.4647.7368 3.8465 3.8465 0 001.6384.0603 4.0058 4.0058 0 003.3502-4.3526zM7.9492 18.627a3.3856 3.3856 0 01-3.1561-.11 3.4752 3.4752 0 01-1.6622-3.3372 3.3087 3.3087 0 012.393-2.7876 3.4225 3.4225 0 013.7146 1.2693c.2749.3765.47.805.5734 1.2595a3.4887 3.4887 0 01-1.8627 3.7053v.0007z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3593 14.0143c-1.2483-.9183-2.4642-1.8626-3.706-2.7875a.2393.2393 0 00-.2457 0c-1.2483.9314-2.49 1.8562-3.7318 2.7875a.2655.2655 0 00-.1164.2911c.4721 1.5134.9443 3.0203 1.4164 4.5337a.2723.2723 0 00.2522.1876c1.5264 0 3.0592-.0712 4.5855-.0776.0129 0 .0129-.0065.0259-.0065a.1527.1527 0 00.1035-.0453c.0064-.0064.0129-.0064.0129-.0129a.155.155 0 00.0453-.0776c.485-1.5199.9636-3.0462 1.4487-4.5726a.2.2 0 00-.0905-.2199zm-1.7916 4.4432c-.9895 0-1.8949.0453-2.878.0324a10.0567 10.0567 0 01-1.2483-.0065c0-.0064 0-.0064-.0064-.0129-.0582-.1682-.1035-.3363-.1552-.511-.3816-1.1964-.7438-2.3929-1.1319-3.5894a.2068.2068 0 00-.0194-.0388l3.3567-2.5224 3.3955 2.4383-1.313 4.2103z",
    fill: "#828A90"
  }), !outline && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6207 9.5351L6.409 9.554c-1.075-.0065-1.9726-.0065-3.054-.0123.0194-2.1181.0317-4.0972.0446-6.2153 2.0987.0065 4.0403-.0065 6.139-.0065.0065 1.005.0446 1.9603.051 2.959 0 .8032.0188 1.5301.0311 2.3334a7.5182 7.5182 0 000 .923z",
    fill: colors[color]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8374 9.5662c-2.1595-.0065-4.3132-.0065-6.4734-.0065 1.093-2.0424 2.2248-4.0655 3.3114-6.1144 1.0477 2.0425 2.1214 4.072 3.162 6.1209z",
    fill: colors[color]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9494 18.6267a3.3866 3.3866 0 01-3.1562-.1099 3.4755 3.4755 0 01-1.662-3.3373 3.3087 3.3087 0 012.393-2.7875 3.4225 3.4225 0 014.2879 2.5288 3.4884 3.4884 0 01-1.8626 3.7059z",
    fill: colors[color]
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8808 14.2473l-1.3129 4.2104c-.9896 0-1.895.0453-2.8781.0324a10.0744 10.0744 0 01-1.2482-.0065c0-.0065 0-.0065-.0065-.0129-.0582-.1682-.1035-.3364-.1552-.511-.3816-1.1965-.7438-2.393-1.1318-3.5895a.2267.2267 0 00-.0194-.0388l3.3566-2.5223 3.3955 2.4382z",
    fill: colors[color]
  })));
});
SvgComponent.defaultProps = {
  color: 'green',
  size: 22,
  outline: false
};
SvgComponent.propTypes = {
  color: PropTypes.oneOf(['green', 'pink']),
  height: PropTypes.number,
  size: PropTypes.number,
  width: PropTypes.number,
  outline: PropTypes.bool
};
export default SvgComponent;